import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Chip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';
import { getOperationStatus } from './useEntryOperationTableColumns';

export { getOperationStatus };

const useDepartureOperationTableColumns = (
  deleteItem,
  editItem,
  openItem,
  apiRef,
  columnPermissions = {},
) => {
  const {
    canDetail = false,
    canEdit = false,
    canDelete = false,
  } = columnPermissions;

  const canViewActions = canDetail || canEdit || canDelete;

  const columnsData = [
    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.title;
      },
    },
    {
      field: 'state',
      headerName: 'وضعیت',
      flex: 0.8,
      minWidth: 130,
      resizable: true,
      editable: false,
      renderCell: params => {
        const status = getOperationStatus(params.row);
        return <Chip size="small" color={status.color} label={status.label} />;
      },
    },
    {
      field: 'voucherTypeDisplay',
      headerName: 'بخش',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },
    {
      field: 'agentName',
      headerName: 'ایجاد کننده',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },
    {
      field: 'shortCode',
      headerName: 'کد',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },
    {
      field: 'dateTime',
      headerName: 'تاریخ',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },
    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 260,
            getActions: params => {
              const buttons = [
                canDetail
                  ? {
                      label: 'جزئیات',
                      Icon: OpenInNewIcon,
                      onClick: openItem(params.row),
                      color: 'primary',
                      variant: 'outlined',
                    }
                  : null,
                canEdit
                  ? {
                      label: 'ویرایش',
                      Icon: ModeEditOutlineIcon,
                      onClick: editItem(params.row),
                      color: 'info',
                    }
                  : null,
              ].filter(Boolean);

              return [
                buttons.length ? (
                  <TableActionButtons key="edit" buttons={buttons} />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key="delete"
                    icon={<DeleteIcon />}
                    label="حذف"
                    onClick={deleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
              ].filter(Boolean);
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useDepartureOperationTableColumns;
